import { render } from "./Fr.vue?vue&type=template&id=df92818a"
import script from "./Fr.vue?vue&type=script&lang=js"
export * from "./Fr.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tony.waddington/Desktop/Vue/gi-video-partners-2/v2-remove_noCodeAPI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__